import PropTypes from 'prop-types';

const contentRowsType = PropTypes.arrayOf(
    PropTypes.shape({
        imgPath: PropTypes.string,
        src: PropTypes.array,
        title: PropTypes.string,
        body: PropTypes.string,
        video: PropTypes.string,
    })
).isRequired;

export default contentRowsType;
